import { FETCH_VITAL_SIGNS } from "../actions/vitalSign";

const initialState = {
    vitalSigns: []
};

export const VitalSignReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case FETCH_VITAL_SIGNS:
            return {
                ...state,
                vitalSigns: action.vitalSigns
            };
        default:
            return state;
    }
};
